import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

import { Id, InboundId, RefDataProductInboundContributorCurrentForm } from './refdata-product-inbound-contributor-current.form';
import { FieldMetadata } from '@cer/cer-data/cer-data-types';

export const RecordReference = "recordReference";

export class RefDataProductInboundCurrentForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    const view = this.productViewGet();
    const contributorView = RefDataProductInboundContributorCurrentForm.contributorView(true);
    contributorView.paneTarget = 'right';
    viewSet.viewAdd(view);
    viewSet.viewAdd(contributorView, view);
  }

  public productViewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'titler-bop', dataApiName: 'RefDataProductInboundCurrent',
        text: 'Titel BOP', textSingular: 'Titel BOP',
        titleFields: [RecordReference],
        primaryKey: 'id', baseFields: ['id'],
        allowEdit: false, allowCreate: false, allowDelete: false,
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'RefDataProductInbound', parentColumn: RecordReference, column: RecordReference } },
//          { link: 'nav', foreignKey: { parentEntity: 'RefDataProductInboundContributorCurrent', parentColumn: InboundId, column: Id } },
          { link: 'nav', foreignKey: { parentEntity: 'DataJobLog', parentColumn: 'id', column: 'modifiedJobId' } }
        ]
      },
      fieldMetadata: RefDataProductInboundCurrentForm.fieldMetadata()
    });
  }

  public static fieldMetadata(): FieldMetadata[] {
    return [
      { name: "headerSenderName", text: 'Afsender', visible: false },
      { name: "headerSentDateTime", text: 'Afsendt', format: 'DateShort' },
      { name: "headerDefaultLanguageOfText", text: "Afsender sprog", visible: false, fieldType: 'language' },
      { name: RecordReference, text: "ONIX reference", width: '120px', orderBy: 'Ascending', visible: false },
      { name: "notificationType", text: "Notifikation", visible: false, filterOnClient: true, filterValue: '05', filterOperator: 'notequal' },
      { name: "recordSourceType", text: "Kildetype", visible: false },
      { name: "recordSourceName", text: "Kilde", visible: false },
      { name: "productISBN", text: "ISBN", width: '120px' },
      { name: "productGTIN", text: "GTIN", visible: false },
      { name: "name", text: "Titel", width: '280px' },
      { name: "nameSub", text: "Undetitel" },
      { name: "nameOriginal", text: "Titel original" },
      { name: "subtitleOriginal", text: "Undertitel original" },
      { name: "collectionSequenceNumber", text: "Serienr." },
      { name: "collectionName", text: "Serietitel" },
      { name: "collectionNameSub", text: "Serieundertitel", visible: false },
      { name: "collectionNameOriginal", text: "Serietitel original" },
      { name: "collectionNameSubOriginal", text: "Serieundertitel original", visible: false },
      { name: "productComposition", text: "Opbygning", visible: false, fieldType: 'productComposition', foreignKeyField: 'onix', foreignKeyValue: 'onixName' },
      { name: "productForm", text: "Format", fieldType: 'productForm', foreignKeyField: 'onix', foreignKeyValue: 'onixName' },
      { name: "productFormDetail", text: "Format, detalje", fieldType: 'productFormDetail', foreignKeyField: 'onix', foreignKeyValue: 'onixName' }, 
      { name: "contributorAuthor", text: "Forfatter"},
      { name: "contributorIllustrator", text: "Illustrator"},
      { name: "contributorPhotographer", text: "Fotograf", visible: false },
      { name: "contributorForeword", text: "Forord", visible: false },
      { name: "contributorTranslator", text: "Oversætter" },
      { name: "contributorCover", text: "Omslagsillustrator", visible: false },
      { name: "contributorTechnicalEditor", text: "Fagredaktør", visible: false },
      { name: "contributorEditor", text: "Redaktør", visible: false },
      { name: "contributorReadBy", text: "Indtalt af", visible: false },
      { name: "editionNumber", text: "Udgave" },
      { name: "language", text: "Sprog", fieldType: 'language' },
      { name: "languageOriginal", text: "Sprog original", fieldType: 'language' },
      { name: "measurementHeightMM", text: "Højde (mm)", format: 'Number' },
      { name: "measurementWidthMM", text: "Bredde (mm)", format: 'Number' },
      { name: "measurementThicknessMM", text: "Dybde (mm)", format: 'Number' },
      { name: "measurementWeightGR", text: "Vægt (g)", format: 'Number' },
      { name: "extendPages", text: "Sideantal", format: 'Number' },
      { name: "subjectKeywords", text: "Søgeord" },
      { name: "subjectThema", text: "Thema" },
      { name: "subjectBookstoreClassification", text: "Varegruppe (boghandler)", foreignKeyTableName: 'ProductCategory', foreignKeyField: 'num', foreignKeyValue: 'search' },
      { name: "contentAudience", text: "Målgruppe" },
      { name: "contentDescription", text: "Salgstekst" },
      { name: "resourceFrontCoverImageLatestUpdate", text: 'Forside ændret', format: 'DateTime' },
      { name: "resourceFrontCoverImageURL", text: 'Forside ', format: 'Url' },
      { name: "publishingImprint", text: "Imprint" },
      { name: "publishingPublisherName", text: "Forlag" },
      { name: "publishingPublisherTypeName", text: "Forlagtype", visible: false },
      { name: "publishingPublisherId", text: "Forlag id" },
      { name: "publishingDate", text: 'Udgivet dato', format: 'DateShort' },
      { name: "publishingDateSalesEmbargo", text: 'Endelig tilmelding dato', format: 'DateShort' },
      { name: "publishingDateFirstPublished", text: 'Først udgivet', format: 'DateYear' },
      { name: "publishingDateLatestReissue", text: 'Genudgivet dato', format: 'DateShort' },
      { name: "publishingLatestReprintNumber", text: "Oplag", format: 'Number' },
      { name: "sourcingManager", fieldType: 'productSourcing' },
      { name: "sourcingSupplier", fieldType: 'productSupplier'},
      { name: "sourcingMinOnhandQty", text: "Min.lager", format: 'Number' },
      { name: "publishingStatus", fieldType: 'productPublishingStatus', foreignKeyField: 'onix', foreignKeyValue: 'onixName' },
      { name: "supplyMarketAvailability", fieldType: 'productMarketAvailability', foreignKeyField: 'onix', foreignKeyValue: 'onixName' },
      { name: "supplySupplierName", text: "Ekspedition" },
      { name: "supplyDate", text: 'Leveres fra', format: 'DateShort' },
      { name: "supplyReturnsCode", text: "Retur kode" },
      { name: "supplyReturnsCodeReplacement", text: "Ombytning kode" },
      { name: "supplyOrderTime", text: 'Leveringstid', format: 'Number' },
      { name: "supplyStockOnhand", text: 'Lager?', format: 'CheckBox' },
      { name: "supplyOrderQtyMin", text: 'Ordreantal minimum', format: 'Number' },
      { name: "salesPrice", text: 'Pris (u.moms)', format: 'Amount' },
      { name: "salesCurrency", text: 'Valuta', visible: false },
      { name: "salesDiscountCode", text: 'Rabatkode' },
      { name: "created", text: 'Oprettet', format: 'DateTime' },
      { name: "createdJobId", text: 'Oprettet id', format: 'Number', visible: false },
      { name: "modified", text: 'Ændret', format: 'DateTime' },
      { name: "modifiedJobId", text: 'Ændret id', format: 'Number', visible: false },
    ];
  }

}

